var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79476 22.0001C7.32809 22.0001 6.14143 23.2001 6.14143 24.6667C6.14143 26.1334 7.32809 27.3334 8.79476 27.3334C10.2614 27.3334 11.4614 26.1334 11.4614 24.6667C11.4614 23.2001 10.2614 22.0001 8.79476 22.0001ZM22.1281 22.0001C20.6614 22.0001 19.4748 23.2001 19.4748 24.6667C19.4748 26.1334 20.6614 27.3334 22.1281 27.3334C23.5948 27.3334 24.7948 26.1334 24.7948 24.6667C24.7948 23.2001 23.5948 22.0001 22.1281 22.0001ZM20.1948 15.3334C21.1948 15.3334 22.0748 14.7867 22.5281 13.9601L27.3014 5.30675C27.7948 4.42675 27.1548 3.33341 26.1414 3.33341H6.40809L5.15476 0.666748H0.794762V3.33341H3.46143L8.26143 13.4534L6.46143 16.7067C5.48809 18.4934 6.76809 20.6667 8.79476 20.6667H24.7948V18.0001H8.79476L10.2614 15.3334H20.1948ZM7.67476 6.00008H23.8748L20.1948 12.6667H10.8348L7.67476 6.00008Z",
    fill: "#32323B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.8052eef450c014dd8db39084611c5c2e.svg";
export { ForwardRef as ReactComponent };